import type { RouteConfig } from '@shared/types/common.types';

import { ACTIVITIES_EVENTS_ROUTES } from './ActivitiesEvents/routes';
import { ADMISSION_ROUTES } from './Admission/routes';
import { APPOINTMENT_GROUP_ROUTES } from './Appointment/routes';
import { CHILDREN_HEALTH_ROUTES } from './Caregivers/Children/CareRecipients/routes';
import { CAREGIVERS_ROUTES } from './Caregivers/FamilyFriends/Caregivers/routes';
import { CARE_RECIPIENT_ROUTES } from './Caregivers/FamilyFriends/CareRecipients/routes';
import { CHATBOT_ROUTES } from './Chatbot/routes';
import { ACCOMPANYING_VISITOR_ROUTES } from './ConsentAndPermission/AccompanyingVisitor/routes';
import { FINANCIAL_CONSENTS_ROUTES } from './ConsentAndPermission/FinancialConsents/routes';
import { NEHR_ACCESS_HISTORY_ROUTES } from './ConsentAndPermission/NehrAccessHistory/routes';
import { NEHR_ACCESS_RESTRICTION_ROUTES } from './ConsentAndPermission/NehrAccessRestriction/routes';
import { HEALTH_ASSESSMENT_ROUTES } from './HealthAssessment/HealthRiskAssessment/routes';
import { SCREENING_LETTER_ROUTES } from './HealthAssessment/ScreeningLetter/routes';
import { HSG_ROUTES } from './HealthierSG/routes';
import { CHILDREN_HEALTH_PROFILE_ROUTES } from './HealthProfile/ChildrenHealthProfile/routes';
import { FAMILY_AND_FRIENDS_HEALTH_PROFILE_ROUTES } from './HealthProfile/FamilyHealthProfile/routes';
import { PERSONAL_HEALTH_ROUTES } from './HealthProfile/PersonalHealthProfile/routes';
import { BIRTH_INFORMATION_ROUTES } from './HealthRecords/BirthInformation/routes';
import { CMIS_ROUTES } from './HealthRecords/CMIS/routes';
import { DEROM_ROUTES } from './HealthRecords/DEROM/routes';
import { DISCHARGE_SUMMARY_ROUTES } from './HealthRecords/DischargeSummary/routes';
import { GROWTH_CHART_ROUTES } from './HealthRecords/GrowthChart/routes';
import { HEALTH_SCREENING_ROUTES } from './HealthRecords/HealthScreening/routes';
import { IMMUNISATION_ROUTES } from './HealthRecords/Immunisation/routes';
import { CHILDREN_HEALTH_MILESTONES_ROUTES } from './HealthRecords/Milestones/routes';
import { MRRP_ROUTES } from './HealthRecords/MRRP/routes';
import { GENETIC_REPORTS_ROUTES } from './HealthRecords/TestReports/Genetic/routes';
import { HISTO_CYTO_REPORTS_ROUTES } from './HealthRecords/TestReports/HistoCyto/routes';
import { LAB_TEST_RESULT_ROUTES } from './HealthRecords/TestReports/LabResult/routes';
import { RADIOLOGY_ROUTES } from './HealthRecords/TestReports/Radiology/routes';
import { HOME_ROUTES } from './Home/routes';
import { HOSPITAL_SERVICE_ROUTES } from './HospitalService/routes';
import { CHILDREN_HEALTH_NOTIFICATION_ROUTES } from './Inbox/ChildrenHealthNotification/routes';
import { CHILDREN_IMMUNISATION_NOTIFICATION_ROUTES } from './Inbox/ChildrenImmunisationNotification/routes';
import { INBOX_NOTIFICATION_ROUTES } from './Inbox/InboxNotification/routes';
import { SCHOOL_HEALTH_NOTIFICATION_ROUTES } from './Inbox/SchoolHealthNotification/routes';
import { MEDREFILL_MODULE_ROUTES } from './Medication/MedRefill';
import { MEDREFILL_HISTORY_ROUTES } from './Medication/MedRefillHistory/routes';
import { PRESCRIPTION_ROUTES } from './Medication/Prescription/routes';
import { LAB_TEST_REPORTS_ROUTES } from './Mobile/LabTestReports/routes';
import { STANDARD_HEALTH_PROFILES_ROUTES } from './Mobile/StandardHealthProfiles/routes';
import { AUTOPAY_ROUTES } from './PaymentsAndFinancial/Autopay/routes';
import { BILL_ROUTES } from './PaymentsAndFinancial/Bills/routes';
import { CHAS_ROUTES } from './PaymentsAndFinancial/CHAS/routes';
import { PAYMENTS_ROUTES } from './PaymentsAndFinancial/Payments/routes';
import { REFUNDS_ROUTES } from './PaymentsAndFinancial/Refunds/routes';
import { PAYMENT_SERVICE_ROUTES } from './PaymentService/routes';
import { PHARMACY_QUEUE_ROUTES } from './PharmacyQueue/routes';
import { SCHOOL_DENTAL_RECORDS_ROUTES } from './School/DentalRecords/routes';
import { SCHOOL_HEALTH_ASSESSMENT_ROUTES } from './School/HealthAssessment/routes';
// TODO: TO BE REMOVED AFTER TESTING
import { SYSTEM_ROUTES } from './System/routes';

export const ROUTES: RouteConfig[] = [
  ...CAREGIVERS_ROUTES,
  ...CARE_RECIPIENT_ROUTES,
  ...APPOINTMENT_GROUP_ROUTES,
  ...ACCOMPANYING_VISITOR_ROUTES,
  ...PERSONAL_HEALTH_ROUTES,
  ...CHILDREN_HEALTH_ROUTES,
  ...BIRTH_INFORMATION_ROUTES,
  ...GROWTH_CHART_ROUTES,
  ...LAB_TEST_RESULT_ROUTES,
  ...PRESCRIPTION_ROUTES,
  ...SCREENING_LETTER_ROUTES,
  ...CHILDREN_HEALTH_MILESTONES_ROUTES,
  ...PAYMENTS_ROUTES,
  ...BILL_ROUTES,
  ...AUTOPAY_ROUTES,
  ...HEALTH_ASSESSMENT_ROUTES,
  ...DISCHARGE_SUMMARY_ROUTES,
  ...NEHR_ACCESS_HISTORY_ROUTES,
  ...NEHR_ACCESS_RESTRICTION_ROUTES,
  ...HSG_ROUTES,
  ...CHATBOT_ROUTES,
  ...HOME_ROUTES,
  ...MEDREFILL_MODULE_ROUTES,
  ...FINANCIAL_CONSENTS_ROUTES,
  ...IMMUNISATION_ROUTES,
  ...RADIOLOGY_ROUTES,
  ...HEALTH_SCREENING_ROUTES,
  ...CMIS_ROUTES,
  ...MRRP_ROUTES,
  ...CHAS_ROUTES,
  ...CHILDREN_HEALTH_PROFILE_ROUTES,
  ...FAMILY_AND_FRIENDS_HEALTH_PROFILE_ROUTES,
  ...MEDREFILL_HISTORY_ROUTES,
  ...SCHOOL_DENTAL_RECORDS_ROUTES,
  ...SCHOOL_HEALTH_ASSESSMENT_ROUTES,
  ...STANDARD_HEALTH_PROFILES_ROUTES,
  ...SYSTEM_ROUTES,
  ...HISTO_CYTO_REPORTS_ROUTES,
  ...LAB_TEST_REPORTS_ROUTES,
  ...GENETIC_REPORTS_ROUTES,
  ...DEROM_ROUTES,
  ...INBOX_NOTIFICATION_ROUTES,
  ...CHILDREN_HEALTH_NOTIFICATION_ROUTES,
  ...CHILDREN_IMMUNISATION_NOTIFICATION_ROUTES,
  ...SCHOOL_HEALTH_NOTIFICATION_ROUTES,
  ...ACTIVITIES_EVENTS_ROUTES,
  ...ADMISSION_ROUTES,
  ...HOSPITAL_SERVICE_ROUTES,
  ...PHARMACY_QUEUE_ROUTES,
  ...REFUNDS_ROUTES,
  ...PAYMENT_SERVICE_ROUTES,
];
